<template lang="pug">
  div.fill-height
    slot(:open="open")
    ModalWrapper(
      icon="file-signature",
      :dialog="dialog",
      :header-text="$t(`form.terms.header`)",
      :max-width="480",
      @close="close",
    )
      template(
        v-if="dialog",
        v-slot:body="",
      )
        v-row
          p.title.mb-2 Scalp Analysis Notice 
          p.mb-2 By completing this scalp analysis e-application form, you agree that Bee Choo Origin Main Outlets may collect, use and disclose your personal data as provided by you, or obtained by us, as a result of your application for scalp analysis or treatment, or for the following purposes: 
          ul
            li processing and administration of your scalp analysis application;
            li taking of photographs/images/videos of your scalp or you, for review, analysis, consultation, advice or treatment;
            li track your scalp condition over time for treatment efficacy;
            li use of the photographs/images/videos of your scalp or you for internal sharing or dissemination, employee training and performance evaluation; and/or
            li 
              | any other purpose reasonably related to the aforementioned purposes, in accordance with the Personal Data Protection Act 2012 and our data protection policy at 
              a(href="https://www.beechoohair.com/legal") https://www.beechoohair.com/legal.
            li 
              | You may visit our website at 
              a(href="https://www.beechoohair.com/legal") https://www.beechoohair.com/legal 
              | for further details on our data protection policy, including how you may access and correct your personal data or withdraw consent to the collection, use or disclosure of your personal data as needed.
      template(v-slot:footer="")
        v-spacer
        v-btn(
          :ripple="false",
          color="primary",
          @click='close'
        ) {{ $t("form.terms.cancel") }}

        v-btn(
          color="primary",
          :ripple="false",
          @click="submit",
        ) {{ $t(`form.terms.confirm`) }}
</template>

<script>
import ModalWrapper from '@/components/wrapper/ModalWrapper.vue';
import { clone, mergeRight, pick, pluck, without } from 'ramda';

export default {
  components: {
    ModalWrapper,
  },

  data: () => ({
    dialog: false,
  }),

  methods: {
    open(isCreate) {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    submit() {
      this.dialog = false;
      this.$emit('submit');
    },
  },
};
</script>
